import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 create_ussd_code: { message: "idle" },
};

export const create_ussd_code_Slice = createSlice({
 name: "create_ussd_code",
 initialState,
 reducers: {
  success_create_ussd_code: (state, action) => {
   state.create_ussd_code = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_create_ussd_code: (state, action) => {
   state.create_ussd_code = { status: app_consts.FAIL, message: action.payload };
  },
  reset_create_ussd_code: (state) => {
   state.create_ussd_code = { status: app_consts.IDLE };
  },
  loading_create_ussd_code: (state) => {
   state.create_ussd_code = { status: app_consts.LOADING };
  },
 }
});

export const { success_create_ussd_code, fail_create_ussd_code, reset_create_ussd_code, loading_create_ussd_code } = create_ussd_code_Slice.actions;

export default create_ussd_code_Slice.reducer;